import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { RolesManager } from "@/components/RolesManager";

export const SectorsSettings = () => {
  const [roles, setRoles] = useState([]);
  const [modules, setModules] = useState([]);

  const load = useCallback(async () => {
    try {
      const [{ data: r }, { data: m }] = await Promise.all([
        axios.get(`${API}/roles`, { withCredentials: true }),
        axios.get(`${API}/permissions/modules`, { withCredentials: true }),
      ]);
      setRoles(r);
      setModules(m.modules);
    } catch { toast.error("Erro ao carregar setores"); }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-2" data-testid="sectors-settings">
      <h2 className="text-lg font-semibold">Setores</h2>
      <RolesManager roles={roles} modules={modules} onChanged={load} />
    </div>
  );
};
